import * as RTabs from '@radix-ui/react-tabs'
import { forwardRef } from 'react'

import { useTabs } from './use-tabs'

export type TabsContentElement = HTMLDivElement

export type TabsContentProps = Omit<React.ComponentProps<typeof RTabs.Content>, 'forceMount'> & {
  forceMount?: boolean
}

const TabsContent = forwardRef<TabsContentElement, TabsContentProps>(function TabsContent(
  props,
  forwardedRef
) {
  const { forceMount = false, ...rest } = props

  const { activeTabValue } = useTabs()

  return (
    <RTabs.Content
      {...rest}
      forceMount={forceMount || undefined}
      hidden={activeTabValue !== rest.value}
      ref={forwardedRef}
    />
  )
})

export default TabsContent
